import Auth from "./pages/auth";
import { useCurrentUser } from "./api-hooks/use-current-user";
import Home from "./pages/chat";
import PageLoader from "./component/page-loader";
import { useDebouncedCallback } from "use-debounce";
import { useEffect, useState } from "react";

const App = () => {
  const { user, loading } = useCurrentUser(true);
  const [isLoading, setIsLoading] = useState(true);

  const debounced = useDebouncedCallback(() => {
    setIsLoading(loading);
  }, 1000);

  useEffect(() => {
    debounced();
  }, [debounced, loading]);

  if (isLoading) return <PageLoader />;

  return user ? <Home /> : <Auth />;
};

export default App;
